export default {
  alpha: '{_field_}須以英文組成',
  alpha_dash: '{_field_}須以英數、斜線及底線組成',
  alpha_num: '{_field_}須以英數組成',
  alpha_spaces: '{_field_}須以英文及空格組成',
  between: '{_field_}須介於 {min} 至 {max}之間',
  confirmed: ' {_field_}不一致',
  digits: '{_field_}須為 {length} 位數字',
  dimensions: '{_field_}圖片尺寸不正確。須為 {width} x {height} 像素',
  email: '{_field_}須為有效的電子信箱',
  excluded: '{_field_}的選項無效',
  ext: '{_field_}須為有效的檔案',
  image: '{_field_}須為圖片',
  integer: '{_field_}須為整數',
  length: '{_field_}的長度須為 {length}',
  max_value: '{_field_}不得大於 {max}',
  max: '{_field_}不能大於 {length} 個字元',
  mimes: '{_field_}須為有效的檔案類型',
  min_value: '{_field_}不得小於 {min}',
  min: '{_field_}不能小於 {length} 個字元',
  not_same: '舊密碼不能和新密碼相同',
  numeric: '{_field_}須為數字',
  oneOf: '{_field_}的選項無效',
  regex: '{_field_}的格式錯誤',
  required: '{_field_}為必填',
  required_if: '{_field_}為必填',
  otpRule: '請輸入正確的郵箱驗證碼',
  pwdRule: '{_field_}長度必須在6-20位之間並包含大寫字母+小寫字母+數字',
  size: '{_field_}的檔案須小於 {size}KB',
  txnPwdValid:'密碼格式錯誤，密碼長度必須在6-20位之間並包含大寫字母+小寫字母+數字'
};
